import * as actionsCrud from "../../crud/action.crud";
import * as contractCrud from "../../crud/contracts.crud";
import store from "../store";
import { select, put, takeLatest, all, call } from "redux-saga/effects";
import Common from '../../shared/common';


export const actionTypes = {
    ACTIONS_SET_PENDING: "[ACTIONS_SET_PENDING]",
    ACTIONS_FETCH_START: "[ACTIONS_FETCH_START]",
    ACTIONS_SET_ACTIONS: "[ACTIONS_SET_ACTIONS]",
    ACTIONS_LOGOUT: "[ACTIONS_LOGOUT]",
};

const initialActionsState = {
    actionsList: null,
    contractOptions: null,
    lastLoadedEpochTime: null,
    pendingFetch: false,

};

export const reducer = (state = initialActionsState, action) => {
    switch (action.type) {
        case actionTypes.ACTIONS_SET_PENDING: {
            return { ...state, pendingFetch: true };
        }
        case actionTypes.ACTIONS_FETCH_START: {
            return { ...state, pendingFetch: false, lastLoadedEpochTime: new Date().getTime() };
        }
        case actionTypes.ACTIONS_SET_ACTIONS: {
            return { ...state, actionsList: action.payload.actionsList, contractOptions: action.payload.contractOptions };
        }
        case actionTypes.ACTIONS_LOGOUT: {
            return initialActionsState;
        }

        default:
            return state;
    }
};

export const actions = {
    fetchStart: (force = false) => {
        const authStore = store.getState().auth;
        const actionsStore = store.getState().actions;

        if (authStore) {
            if (!authStore.authToken.token || !authStore.csrfToken.token) {
                if (!actionsStore.pendingFetch) {
                    return { type: actionTypes.ACTIONS_SET_PENDING };
                }
                return { type: '' };
            }
        }

        if (!actionsStore.pendingFetch && !force && actionsStore) {
            //DO NOT REPEAT REQUEST IN LESS THAN (REACT_APP_CACHE_TIMEOUT_ACTIONS) seconds
            if (actionsStore.lastLoadedEpochTime) {
                const cacheTimeoutSec = Number(process.env.REACT_APP_CACHE_TIMEOUT_ACTIONS);
                if (new Date(actionsStore.lastLoadedEpochTime + (cacheTimeoutSec * 1000)) > new Date()) {
                    // console.log(`Actions loaded less than ${((cacheTimeoutSec) / 60)} minute ago!`);
                    return { type: '' };
                }
            }
        }
        return { type: actionTypes.ACTIONS_FETCH_START };
    },
    setPending: () => ({ type: actionTypes.ACTIONS_SET_PENDING }),
    setActions: (actionsList, contractOptions) => ({ type: actionTypes.ACTIONS_SET_ACTIONS, payload: { actionsList, contractOptions } }),
    logout: () => ({ type: actionTypes.ACTIONS_LOGOUT })
};
export function* saga() {

    yield takeLatest([actionTypes.ACTIONS_FETCH_START], function* actionsLoadActionsSaga() {
        try {
            // const response = yield actionsCrud.getDashboard();

            const dashboardItemResults = yield all(
                [
                    call(actionsCrud.getDashboard),
                    call(contractCrud.toSelectList)
                ]
            );

            let { data: actionsList } = dashboardItemResults[0];
            const { data: contractOptions } = dashboardItemResults[1];
            let contractsGrouped = Common.GroupBy(contractOptions, 'contractid');
            let dbPartyNameMappings = {
                Contractor: 1,
                PM: 2,
                Supervisor: 3,
                Client: 4
            };
            //assgin additional contract properties from contracts list
            actionsList = actionsList.map(action => {
                if (action._2) {
                    let mycontractparty = dbPartyNameMappings[contractsGrouped[action._2][0].myparty];
                    return { ...action, mycontractparty, actionmatchesmyparty: mycontractparty === action._6 };
                }
                return action;
            });

            yield put(actions.setActions(actionsList, contractOptions));
        }
        catch (err) {
            console.log("Error in actionsLoadActionsSaga:", err);
        }

    });
}
